import { render, staticRenderFns } from "./SourceDialog.vue?vue&type=template&id=12dec380&scoped=true"
import script from "./SourceDialog.vue?vue&type=script&lang=js"
export * from "./SourceDialog.vue?vue&type=script&lang=js"
import style0 from "./SourceDialog.vue?vue&type=style&index=0&id=12dec380&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dec380",
  null
  
)

export default component.exports